import * as angular from 'angular';
import {AccountRequests} from "../../account/services/account-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ConfigurationProfilesAlertsService} from "./configuration-profiles-alerts.service";
import {ConfigurationProfilesRequestsService} from "./configuration-profiles-requests.service";
import {AccountModel} from "../../account/angular/models/account.model";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";

export class ConfigurationProfilesService {

  constructor(private bringozLoaderService: BringozLoaderService, private configurationProfilesRequestsService: ConfigurationProfilesRequestsService, private $log,
              private confirmDialogService: ConfirmDialogService, private configurationProfilesAlertsService: ConfigurationProfilesAlertsService, private accountRequests: AccountRequests) {
  }

  createOne(configurationProfile) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.configurationProfilesRequestsService.createOne(configurationProfile)
        .then((newConfigurationProfile) => {
          this.configurationProfilesAlertsService.createSuccess();
          resolve(newConfigurationProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.createError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  duplicateOne(configurationProfile) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.configurationProfilesRequestsService.createOne(configurationProfile)
        .then((newConfigurationProfile) => {
          this.configurationProfilesAlertsService.duplicateSuccess();
          resolve(newConfigurationProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.duplicateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  getOne(id: string) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.configurationProfilesRequestsService.getOne(id)
        .then((profile) => {
          resolve(profile);
        })
        .catch((error) => {
          this.$log.error(error);
          // this.configurationProfilesAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateOne(profile) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.configurationProfilesRequestsService.updateOne(profile)
        .then((updatedProfile) => {
          this.configurationProfilesAlertsService.updateSuccess();
          resolve(updatedProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateAccountProfile(profile, accountId) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.accountRequests.updateAccountProfile(profile, accountId)
        .then((updatedProfile) => {
          this.configurationProfilesAlertsService.updateSuccess();
          resolve(updatedProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  deleteOne(profileId) {
    const text = 'Are you sure you want to remove this configuration profile?'
    return this.confirmDialogService.confirm('Remove Configuration Profile', text)
      .then(() => {
        return this.delete(profileId)
      })
  }

  assignAccountsToProfile(profileId: string, accountIds: string[]) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.configurationProfilesRequestsService.assignAccountsToProfile(profileId, accountIds)
        .then((accounts: AccountModel[]) => {
          this.configurationProfilesAlertsService.updateAccountsSuccess();
          resolve(accounts);
        })
        .catch((error) => {
          this.$log.error(error);
          this.configurationProfilesAlertsService.updateAccountsError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  getDefaultProfile() {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.configurationProfilesRequestsService.getDefaultProfile()
        .then((defaultProfile) => {
          resolve(defaultProfile[0]);
        })
        .catch((error) => {
          this.$log.error(error);
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  private delete(profileId) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.configurationProfilesRequestsService.deleteOne(profileId)
        .then((removedProfile) => {
          this.configurationProfilesAlertsService.removeSuccess();
          resolve(removedProfile);
        })
        .catch((error) => {
          this.$log.error(error);
          if (error.code === 400408) {
            this.configurationProfilesAlertsService.removeUsedError();
          } else this.configurationProfilesAlertsService.removeError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

}

angular
  .module('bringoz.admin.configuration-profiles')
  .service('configurationProfilesService', ConfigurationProfilesService);
